module.exports = __webpack_public_path__ + "img/dep-just-sky.23d22372.png";